export default "__VITE_ASSET__BYPfCMEO__"